import { render, staticRenderFns } from "./editAction.vue?vue&type=template&id=c878e3ac&scoped=true"
import script from "./editAction.vue?vue&type=script&lang=js"
export * from "./editAction.vue?vue&type=script&lang=js"
import style0 from "./editAction.vue?vue&type=style&index=0&id=c878e3ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c878e3ac",
  null
  
)

export default component.exports